import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginError: string;
  public loginInProgress: boolean = false;

  constructor(public ucdService: UserCourseDataService, private route: ActivatedRoute, public router: Router, public modal: NgbActiveModal) { 
    ucdService.User.subscribe(user => {
      if(ucdService.IsLoggedIn) {
        this.CloseLoginModal();
      }
    })
  }

  ngOnInit() {
    if(this.ucdService.IsLoggedIn) {
      this.CloseLoginModal();
    }
  }

  public CloseLoginModal() {
    this.loginInProgress = false;
    this.loginError = null;
    this.modal.close();
  }

  submitLogin(loginForm: UntypedFormGroup) {
    this.loginInProgress = true;
    this.ucdService.Login(loginForm.value.user_email, loginForm.value.user_password).subscribe(user => {
      if (this.ucdService.IsLoggedIn) {
        this.modal.close(true);
      } else {
        this.loginError = user.LoginError;
      }
      this.loginInProgress = false;
    });
  }
}
